export default {
  isLoggedIn: ({ user }) => !!user?.token,
  userId: ({ user }) => user?.id,
  username: ({ user }) => user?.username,
  fullName: ({ user }) =>
    `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
  accessToken: ({ user }) => user?.token,
  role: ({ user }) => user?.role,
};
